import * as Yup from "yup";

export const bannerSchema = Yup.object().shape({
  displayFromDate: Yup.date()
    .typeError("displayFrom date must be a valid date")
    .required("displayFrom date is required"),

  displayFromTime: Yup.string()
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
      "displayFrom time must be a valid time string (HH:mm:ss)"
    )
    .required("displayFrom time is required"),

  displayToDate: Yup.date()
    .typeError("displayTo date must be a valid date")
    .required("displayTo date is required"),

  displayToTime: Yup.string()
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
      "displayTo time must be a valid time string (HH:mm:ss)"
    )
    .required("displayTo time is required"),

  message: Yup.string()
    .required("Message is required")
    .max(120, "Message cannot exceed 120 characters"),
});
